export default {"src":"https://marketplace-web-assets.vinted.com/_next/static/media/fr.42d17f6d.svg","height":40,"width":127,"blurWidth":0,"blurHeight":0};